export const noQCode = (qcode: string) => qcode.length === 0;
